module.exports = __webpack_public_path__ + "img/tableau_kanban.615de275.png";